import { IPaginationElement } from './pagination';

export class AbsorcionesGrupo implements IPaginationElement {

    id: number;
    grupoAbsorbido: string;
    grupoDestino: string;
    usuarioAbsorcion: number;
    eliminada: boolean;
    fechaAbsorcion: Date;
    nombreCliente: string;
    haSidoAbsorbido: string;

    constructor() { }


    static toModel(json: string): AbsorcionesGrupo {
        const data = JSON.parse(json);
        if (data === null) {
            return null;
        }
        const toReturn = new AbsorcionesGrupo();
        toReturn.id = data.ID;
        toReturn.grupoAbsorbido = data.GRUPO_ABSORBIDO;
        toReturn.grupoDestino = data.GRUPO_DESTINO;
        toReturn.usuarioAbsorcion = data.USUARIO_ABSORCION;

        toReturn.eliminada = data.ELIMINADA == 0 ? false : true;
        toReturn.fechaAbsorcion = data.FECHA_ABSORCION;
        toReturn.nombreCliente = data.CLIENT_NAME;
        toReturn.haSidoAbsorbido = data.ABSORBIDO;
        return toReturn;
    }
}
